import { FC } from 'react';

export type StatusIndicatorProps = {
  /**
   * at the moment delivered (green) only status
   */
  status: 'sent' | 'delivered';
  text: string;
};

const BASE_STATUSINDICATOR_CLASSES =
  'text-white font-2xl px-1 py-px rounded inline-block';
const DELIVERED_STATUSINDICATOR_CLASSES = 'bg-green-200';
const SENT_STATUSINDICATOR_CLASSES = 'bg-yellow-100';

export const StatusIndicator: FC<StatusIndicatorProps> = ({
  status = 'delivered',
  text = 'Briefing delivered',
}: StatusIndicatorProps) => {
  const statusClass =
    status === 'delivered'
      ? DELIVERED_STATUSINDICATOR_CLASSES
      : SENT_STATUSINDICATOR_CLASSES;
  return (
    <div className={`${BASE_STATUSINDICATOR_CLASSES} ${statusClass}`}>
      {text}
    </div>
  );
};
